// extracted by mini-css-extract-plugin
export default {"green-icon":"style_green-icon__Za6xY","red-icon":"style_red-icon__IfVOD"};